"use client"

import { clx } from "@medusajs/ui"

export type SortOptions = "price_asc" | "price_desc" | "created_at"

type SortProductsProps = {
  sortBy: SortOptions
  setQueryParams: (name: string, value: SortOptions) => void
  "data-testid"?: string
}

const sortOptions: { value: SortOptions; label: string }[] = [
  {
    value: "created_at",
    label: "Newest",
  },
  {
    value: "price_asc",
    label: "Price: Low to High",
  },
  {
    value: "price_desc",
    label: "Price: High to Low",
  },
]

const SortProducts = ({
  "data-testid": dataTestId,
  sortBy,
  setQueryParams,
}: SortProductsProps) => {
  const handleChange = (value: SortOptions) => {
    setQueryParams("sortBy", value)
  }

  return (
    <div className="flex flex-col gap-y-3" data-testid={dataTestId}>
      <span className="text-muted text-xs font-semibold uppercase tracking-wide">
        Sort by
      </span>
      <div className="flex flex-col gap-y-2">
        {sortOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => handleChange(option.value)}
            data-testid="radio-label"
            data-active={option.value === sortBy}
            className={clx(
              "text-left text-sm transition-colors hover:cursor-pointer hover:text-clay",
              {
                "text-clay font-medium": option.value === sortBy,
                "text-muted": option.value !== sortBy,
              }
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default SortProducts
